// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const MessengerIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'messenger'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1C5.92486 1 1 5.56004 1 11.1852C1 14.3905 2.59958 17.2495 5.09938 19.1165V23L8.84478 20.9444C9.84434 21.2211 10.9033 21.3704 12 21.3704C18.0751 21.3704 23 16.8103 23 11.1852C23 5.56004 18.0751 1 12 1ZM13.0932 14.7161L10.2919 11.7285L4.8261 14.7161L10.8385 8.33339L13.7081 11.321L19.1056 8.33339L13.0932 14.7161Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
MessengerIcon.displayName = 'MessengerIcon'
export { MessengerIcon }
